"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Arrows = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./arrows");
});
var Bullets = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./bullets");
});
var Slider = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./slider");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      display: "flex",
      flex: 1,
      height: "100%",
      overflow: "hidden"
    },
    wrapper: {
      display: "flex",
      flex: 1,
      position: "relative"
    }
  };
});

var ReactAnimation = function ReactAnimation(_ref) {
  var _ref$absoluteMediaURL = _ref.absoluteMediaURLs,
      absoluteMediaURLs = _ref$absoluteMediaURL === void 0 ? false : _ref$absoluteMediaURL,
      api = _ref.api,
      data = _ref.data,
      id = _ref.id,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      mediaFormats = _ref.mediaFormats,
      prevIcon = _ref.prevIcon,
      nextIcon = _ref.nextIcon,
      _ref$showArrows = _ref.showArrows,
      showArrows = _ref$showArrows === void 0 ? false : _ref$showArrows,
      _ref$showBullets = _ref.showBullets,
      showBullets = _ref$showBullets === void 0 ? false : _ref$showBullets,
      _ref$textComponents = _ref.textComponents,
      textComponents = _ref$textComponents === void 0 ? {
    text1: "p",
    text2: "p"
  } : _ref$textComponents,
      _ref$textVariants = _ref.textVariants,
      textVariants = _ref$textVariants === void 0 ? {
    text1: "h1",
    text2: "h3"
  } : _ref$textVariants,
      _ref$webpFallback = _ref.webpFallback,
      webpFallback = _ref$webpFallback === void 0 ? false : _ref$webpFallback;

  var _useState = (0, _react.useState)(data !== null && data !== void 0 ? data : {}),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      slide = _useState4[0],
      setSlide = _useState4[1];

  var _animationTimer = (0, _react.useRef)();

  var css = useStyles();
  var _options$entries = options.entries,
      entries = _options$entries === void 0 ? 0 : _options$entries,
      _options$items = options.items,
      items = _options$items === void 0 ? [] : _options$items;
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setSlide(0);
    }, 100);
  }, [options]); // clean up

  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(_animationTimer.current);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var playAnimation = function playAnimation() {
      clearTimeout(_animationTimer.current);
      _animationTimer.current = setTimeout(function () {
        if (slide === entries - 1) {
          setSlide(0);
        } else {
          setSlide(slide + 1);
        }
      }, 5000);
    };

    playAnimation();
  }, [entries, slide]);
  (0, _react.useEffect)(function () {
    if (data) return;

    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var fetchURL, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetchURL = "".concat(api, "?lang=").concat(lang);
                if (id) fetchURL += "&id=".concat(id);
                _context.next = 4;
                return fetch(fetchURL);

              case 4:
                response = _context.sent;

                if (!(response.status !== 200)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("No animation found!");

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                data = _context.sent;
                setOptions(data);
                return _context.abrupt("return", data);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [api, data, id, lang]);

  var handleChange = function handleChange(id) {
    setSlide(id);
  };

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)("mco-animation-01", css.root)
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)("mco-animation-01__wrapper", css.wrapper)
  }, entries > 0 && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(Slider, {
    absoluteMediaURLs: absoluteMediaURLs,
    active: slide,
    items: items,
    mediaFormats: mediaFormats,
    textStyles: {
      textComponents: textComponents,
      textVariants: textVariants
    },
    webpFallback: webpFallback
  })), showArrows && entries > 1 && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(Arrows, {
    active: slide,
    entries: entries,
    prevIcon: prevIcon,
    nextIcon: nextIcon,
    onChange: function onChange(id) {
      return handleChange(id);
    }
  })), showBullets && entries > 1 && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(Bullets, {
    active: slide,
    counter: entries,
    onChange: function onChange(id) {
      return handleChange(id);
    }
  }))));
};

ReactAnimation.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  api: _propTypes.default.string,
  id: _propTypes.default.number,
  images: _propTypes.default.array,
  lang: _propTypes.default.string,
  mediaFormats: _propTypes.default.object,
  prevIcon: _propTypes.default.object,
  nextIcon: _propTypes.default.object,
  showArrows: _propTypes.default.bool,
  showBullets: _propTypes.default.bool,
  webpFallback: _propTypes.default.bool
};
var _default = ReactAnimation;
exports.default = _default;